// extracted by mini-css-extract-plugin
export default {"mainContainer":"Profile_mainContainer__J1ZFH","title":"Profile_title__YSEC2","deleteContainer":"Profile_deleteContainer__oLCcV","buttonDelete":"Profile_buttonDelete__7Taqp"};